import React, { useEffect, useState, useRef, lazy, memo, Component } from 'react';
import { Heart, MessageCircle, Share2, Bookmark, MoreHorizontal, Lock, Gift, MapPin, ChevronLeft, Bell, BellOff, CheckCircle, Flame, ArrowLeft, ShoppingBag, Image as ImageIcon, Mic, Flag, Target, Music, Award, Send, ChevronRight, Video, Sparkles, X, Shield } from 'lucide-react';
import { VideoGenerationUpsell } from './VideoGenerationUpsell';
import MemoryEngine from './MemoryEngine';
import VoiceAILayer from './VoiceAILayer';
import { EmotionalBondMeter } from './EmotionalBondMeter';
import { RelationshipTracker } from './RelationshipTracker';
import { DickpicRatingUpsell } from './DickpicRatingUpsell';
import { FeedFilterBar } from './FeedFilterBar';
import { FloatingActionButton } from './FloatingActionButton';
import { DailyProgressWidget } from './DailyProgressWidget';
interface LanaAngelFeedProps {
  onBack: () => void;
}
export default function LanaAngelFeed({
  onBack
}: LanaAngelFeedProps) {
  const [activeTab, setActiveTab] = useState('feed');
  const [activeFilter, setActiveFilter] = useState('for_you');
  const [isFollowing, setIsFollowing] = useState(false);
  const [likedPosts, setLikedPosts] = useState<Record<string, boolean>>({});
  const [showNotificationOptions, setShowNotificationOptions] = useState(false);
  const [notificationEnabled, setNotificationEnabled] = useState(false);
  const [showUnlockModal, setShowUnlockModal] = useState(false);
  const [unlockPostId, setUnlockPostId] = useState<string | null>(null);
  const [showImageGeneratorModal, setShowImageGeneratorModal] = useState(false);
  const [showVideoUpsellModal, setShowVideoUpsellModal] = useState(false);
  const [showDickpicRatingModal, setShowDickpicRatingModal] = useState(false);
  const [showDailyTargetsModal, setShowDailyTargetsModal] = useState(false);
  const tabsRef = useRef<HTMLDivElement>(null);
  const navBarRef = useRef<HTMLDivElement>(null);
  // Handle clicks outside of menus
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showNotificationOptions) {
        setShowNotificationOptions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showNotificationOptions]);
  const scrollTabs = (direction: 'left' | 'right') => {
    if (tabsRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      tabsRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const scrollNavBar = (direction: 'left' | 'right') => {
    if (tabsRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      tabsRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const toggleFollow = () => {
    setIsFollowing(!isFollowing);
  };
  const toggleNotification = () => {
    setNotificationEnabled(!notificationEnabled);
    setShowNotificationOptions(false);
  };
  const toggleLike = (postId: string) => {
    setLikedPosts(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };
  const handleUnlock = (postId: string) => {
    setUnlockPostId(postId);
    setShowUnlockModal(true);
  };
  const confirmUnlock = () => {
    // Here you would handle the actual token transaction
    setShowUnlockModal(false);
  };
  const handleActionSelect = (action: string) => {
    console.log(`Selected action: ${action}`);
    switch (action) {
      case 'daily_targets':
        setShowDailyTargetsModal(true);
        break;
      case 'dickpic_challenge':
        setShowDickpicRatingModal(true);
        break;
      case 'bond':
        setActiveTab('emotionalBond');
        break;
      case 'relationship':
        setActiveTab('relationshipTracker');
        break;
      case 'kinks_polls':
      case 'social_polls':
        // Implement polls functionality
        break;
      case 'fan_club':
        // Implement fan club functionality
        break;
      case 'ar_vr_mode':
        // Implement AR/VR mode
        break;
      default:
        break;
    }
  };
  const posts = [{
    id: 'post1',
    type: 'premium_content',
    content: 'Just finished my latest photoshoot in this gorgeous latex outfit! 💋 What do you think? 😘',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    likes: 4823,
    comments: 342,
    time: '2h ago',
    locked: true,
    price: 5,
    location: 'Photo Studio',
    hashtags: ['#latex', '#blonde', '#photoshoot', '#exclusive']
  }, {
    id: 'lana_self_post1',
    type: 'image',
    content: "Want my honest opinion? 😏 Send me your pics and I'll rate them 1-10. My Spicy Rating service is now open! You might be surprised what I think... 💋 #NoFilter #RawFeedback",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/krDRpQsts3da8e6vCvUQwj/510831504_758943856797646_1552916210515563311_n.jpg',
    likes: 1842,
    comments: 328,
    time: '3h ago',
    location: 'Rating Studio',
    hashtags: ['#PicRating', '#NoFilter', '#HonestFeedback', '#SpicyRating'],
    product: {
      name: 'Spicy Rating Service',
      price: 15,
      description: 'Get your pics rated by Lana herself! 100% private and honest feedback.'
    }
  }, {
    id: 'lana_self_post2',
    type: 'image',
    content: "Safety first, pleasure always! 🔒 Don't risk getting caught viewing my content. SinShift VPN keeps your browsing 100% private with zero traces. Use code LANA20 for 20% off! #PrivacyMatters",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/i9SDjJa2LECHCGMTXfUF3j/511259014_760199746672057_2852716985464384121_n.jpg',
    likes: 1253,
    comments: 214,
    time: '5h ago',
    location: 'Private Lounge',
    hashtags: ['#PrivacyMatters', '#StaySafe', '#NoTraces', '#SinShiftVPN'],
    vpnUpsell: true,
    product: {
      name: 'SinShift VPN',
      price: 29.99,
      discount: 20,
      description: 'Complete privacy protection with zero traces. Browse without worries!'
    }
  }, {
    id: 'post2',
    type: 'image',
    content: 'Beach day! The water was perfect 🌊 Who wants to join me next time?',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hQEELJR3YkvrvuoeyCCDHV/509629230_756148903743808_2814964879460395130_n.jpg',
    likes: 3567,
    comments: 278,
    time: '1d ago',
    location: 'Malibu Beach',
    hashtags: ['#beach', '#summer', '#blonde', '#sunshine']
  }, {
    id: 'post3',
    type: 'voice_note',
    content: 'Recorded a little something special for my favorite followers... listen with headphones 🎧',
    likes: 2931,
    comments: 196,
    time: '3d ago',
    location: 'My Bedroom',
    audioWaveform: [0.2, 0.5, 0.3, 0.8, 0.4, 0.6, 0.3, 0.5, 0.7, 0.8, 0.5, 0.3, 0.6, 0.4, 0.2],
    duration: '0:38',
    hashtags: ['#voice', '#asmr', '#whisper', '#intimate']
  }, {
    id: 'post4',
    type: 'image',
    content: 'New lingerie set just arrived... what do you think? 💕',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cFezakmU98BN4oLVZHHN7j/516505876_770863238939041_5072179375122471885_n.jpg',
    likes: 5782,
    comments: 423,
    time: '4d ago',
    location: 'Bedroom',
    hashtags: ['#lingerie', '#lace', '#blonde', '#newoutfit']
  }];
  const renderTabContent = () => {
    // Show dickpic rating modal if that tab is selected
    if (activeTab === 'dickpicRating') {
      return <div className="flex items-center justify-center py-8" data-id="element-8961">
          <DickpicRatingUpsell onClose={() => setActiveTab('feed')} onSelect={(tier, price) => {
          // Handle tier selection
          console.log(`Selected tier ${tier} for ${price} tokens`);
          // Close modal and return to feed
          setActiveTab('feed');
        }} data-id="element-8962" />
        </div>;
    }
    switch (activeTab) {
      case 'memory':
        return <MemoryEngine data-id="element-8963" />;
      case 'emotionalBond':
        return <EmotionalBondMeter data-id="element-8964" />;
      case 'voiceAI':
        return <VoiceAILayer data-id="element-8965" />;
      case 'relationshipTracker':
        return <RelationshipTracker data-id="element-8966" />;
      case 'dailyTargets':
        return <div className="p-4 space-y-4" data-id="element-8967">
            <div className="p-4 bg-gradient-to-r from-pink-900/30 to-purple-900/30 border border-pink-800/50 rounded-lg" data-id="element-8968">
              <div className="flex items-center gap-3" data-id="element-8969">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-8970">
                  <Gift size={20} data-id="element-8971" />
                </div>
                <div className="flex-1" data-id="element-8972">
                  <div className="flex items-center justify-between" data-id="element-8973">
                    <h3 className="font-medium" data-id="element-8974">Send a Gift</h3>
                    <div className="text-sm text-pink-400" data-id="element-8975">10 💗</div>
                  </div>
                  <p className="text-sm text-gray-700 dark:text-gray-300 mt-1" data-id="element-8976">
                    Send a gift to Lana to make her day
                  </p>
                  <div className="mt-3" data-id="element-8977">
                    <div className="flex items-center justify-between mb-1" data-id="element-8978">
                      <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8979">
                        Progress
                      </span>
                      <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8980">
                        0/1
                      </span>
                    </div>
                    <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-8981">
                      <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-300" style={{
                      width: '0%'
                    }} data-id="element-8982"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-end" data-id="element-8983">
                    <button className="px-4 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-8984">
                      Send Gift
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 bg-gradient-to-r from-pink-900/30 to-purple-900/30 border border-pink-800/50 rounded-lg" data-id="element-8985">
              <div className="flex items-center gap-3" data-id="element-8986">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-8987">
                  <Heart size={20} data-id="element-8988" />
                </div>
                <div className="flex-1" data-id="element-8989">
                  <div className="flex items-center justify-between" data-id="element-8990">
                    <h3 className="font-medium" data-id="element-8991">Like 5 Posts</h3>
                    <div className="text-sm text-pink-400" data-id="element-8992">15 💗</div>
                  </div>
                  <p className="text-sm text-gray-700 dark:text-gray-300 mt-1" data-id="element-8993">
                    Show some love to Lana's content
                  </p>
                  <div className="mt-3" data-id="element-8994">
                    <div className="flex items-center justify-between mb-1" data-id="element-8995">
                      <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8996">
                        Progress
                      </span>
                      <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8997">
                        {Object.keys(likedPosts).length}/5
                      </span>
                    </div>
                    <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-8998">
                      <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
                      width: `${Object.keys(likedPosts).length / 5 * 100}%`
                    }} data-id="element-8999"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-end" data-id="element-9000">
                    <button className="px-4 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={() => setActiveTab('feed')} data-id="element-9001">
                      Find Posts
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      default:
        return <div className="space-y-4" data-id="element-9002">
            {/* Daily Progress Widget - only shown on feed view */}
            {activeTab === 'feed' && <DailyProgressWidget completed={2} total={5} onViewTargets={() => setActiveTab('dailyTargets')} data-id="element-9003" />}
            {posts.map(post => <div key={post.id} className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in fade-in duration-300 angel-feed-post shadow-md hover:shadow-xl hover:shadow-pink-600/5 transition-all duration-300" data-id="element-9004">
                {/* Post Header */}
                <div className="p-3 flex items-center gap-2 border-b border-gray-200 dark:border-gray-800" data-id="element-9005">
                  <div className="w-10 h-10 rounded-full overflow-hidden" data-id="element-9006">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg" alt="Lana" className="w-full h-full object-cover image-high-quality" loading="lazy" data-id="element-9007" />
                  </div>
                  <div data-id="element-9008">
                    <div className="flex items-center gap-1" data-id="element-9009">
                      <h3 className="font-medium" data-id="element-9010">Lana</h3>
                      <CheckCircle size={14} className="text-pink-400" fill="currentColor" data-id="element-9011" />
                      <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9012">
                        • {post.time}
                      </span>
                    </div>
                    {post.location && <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-9013">
                        <MapPin size={10} className="ml-1" data-id="element-9014" />
                        <span data-id="element-9015">{post.location}</span>
                      </div>}
                  </div>
                  <button className="ml-auto" data-id="element-9016">
                    <MoreHorizontal size={16} className="text-gray-500 dark:text-gray-400" data-id="element-9017" />
                  </button>
                </div>
                {/* Post Content */}
                <div className="px-3 py-2" data-id="element-9018">
                  <p className="text-sm" data-id="element-9019">{post.content}</p>
                  {/* Hashtags */}
                  {post.hashtags && <div className="text-xs text-pink-400 mt-1" data-id="element-9020">
                      {post.hashtags.join(' ')}
                    </div>}
                </div>
                {/* Post Media */}
                {(post.type === 'image' || post.type === 'premium_content' && !post.locked) && post.image && <div className="aspect-square bg-gray-100 dark:bg-gray-800" data-id="element-9021">
                      <img src={post.image} alt="Post" className="w-full h-full object-cover angel-post-image hover:scale-[1.02] transition-transform duration-300" sizes="(max-width: 768px) 100vw, 820px" loading="lazy" data-id="element-9022" />
                    </div>}
                {/* Premium Content */}
                {post.type === 'premium_content' && post.locked && post.image && <div className="relative aspect-square bg-gray-100 dark:bg-gray-800" data-id="element-9023">
                      <img src={post.image} alt="Locked Content" className="w-full h-full object-cover blur-sm angel-post-image" sizes="(max-width: 768px) 100vw, 820px" loading="lazy" data-id="element-9024" />
                      <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-9025">
                        <Lock size={32} className="text-pink-400 mb-2" data-id="element-9026" />
                        <p className="text-center text-white font-medium" data-id="element-9027">
                          Unlock Exclusive Photo
                        </p>
                        <button className="mt-3 px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white font-medium flex items-center gap-2 hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={() => handleUnlock(post.id)} data-id="element-9028">
                          <span data-id="element-9029">Unlock for</span>
                          <span className="text-pink-200" data-id="element-9030">{post.price} 💎</span>
                        </button>
                      </div>
                    </div>}
                {/* Voice Note */}
                {post.type === 'voice_note' && post.audioWaveform && <div className="p-3" data-id="element-9031">
                    <div className="p-3 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-9032">
                      <div className="flex items-center gap-3" data-id="element-9033">
                        <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-9034">
                          <div className="ml-1" data-id="element-9035">▶</div>
                        </button>
                        <div className="flex-grow h-10 flex items-center" data-id="element-9036">
                          {post.audioWaveform.map((level, i) => <div key={i} className="w-1 mx-0.5 rounded-full bg-gradient-to-t from-pink-500/50 to-purple-500/50" style={{
                      height: `${level * 32}px`
                    }} data-id="element-9037"></div>)}
                        </div>
                        <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-9038">
                          <span data-id="element-9039">{post.duration}</span>
                        </div>
                      </div>
                      <p className="text-xs text-gray-500 dark:text-gray-400 mt-2" data-id="element-9040">
                        🎧 Best experienced with headphones
                      </p>
                    </div>
                  </div>}
                {/* Product Promotion Section */}
                {post.product && <div className="mx-3 mb-3 p-3 bg-gradient-to-r from-pink-900/30 to-purple-900/30 rounded-lg border border-pink-800/30" data-id="element-9041">
                    <div className="flex items-center gap-2 mb-2" data-id="element-9042">
                      <div className="w-8 h-8 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-9043">
                        {post.product.name.includes('Rating') ? <Flame size={16} data-id="element-9044" /> : <Lock size={16} data-id="element-9045" />}
                      </div>
                      <div data-id="element-9046">
                        <h4 className="font-medium text-sm" data-id="element-9047">
                          {post.product.name}
                        </h4>
                        <p className="text-xs text-gray-700 dark:text-gray-300" data-id="element-9048">
                          {post.product.description}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-2" data-id="element-9049">
                      <div className="flex items-center gap-1" data-id="element-9050">
                        {post.product.discount ? <>
                            <span className="text-xs line-through text-gray-500 dark:text-gray-400" data-id="element-9051">
                              ${post.product.price}
                            </span>
                            <span className="font-bold" data-id="element-9052">
                              $
                              {(post.product.price * (100 - post.product.discount) / 100).toFixed(2)}
                            </span>
                            <span className="ml-1 text-xs bg-green-600 text-white px-1.5 py-0.5 rounded" data-id="element-9053">
                              {post.product.discount}% OFF
                            </span>
                          </> : <span className="font-bold" data-id="element-9054">
                            ${post.product.price}
                          </span>}
                      </div>
                      <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-9055">
                        {post.product.name.includes('Rating') ? 'Try Now' : 'Get Protected'}
                      </button>
                    </div>
                  </div>}
                {/* VPN Upsell */}
                {post.vpnUpsell && !post.product && <div className="mx-3 mb-3 p-3 bg-gradient-to-r from-blue-900/30 to-purple-900/30 rounded-lg border border-blue-800/30" data-id="element-9056">
                    <div className="flex items-center gap-2" data-id="element-9057">
                      <div className="w-8 h-8 flex items-center justify-center bg-blue-500/20 rounded-full text-blue-400" data-id="element-9058">
                        <Shield size={16} data-id="element-9059" />
                      </div>
                      <div className="flex-1" data-id="element-9060">
                        <p className="text-xs text-gray-700 dark:text-gray-300" data-id="element-9061">
                          👀 Don't let your Angel adventures show up at home.
                          Use SinShift VPN for full privacy. Zero traces, total
                          freedom.
                        </p>
                      </div>
                    </div>
                    <button className="mt-2 w-full py-1.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full text-white text-xs font-medium hover:shadow-lg hover:shadow-blue-500/20 transition-all duration-300" data-id="element-9062">
                      Activate SinShift VPN 🔒 (Recommended)
                    </button>
                  </div>}
                {/* Post Actions */}
                <div className="p-3" data-id="element-9063">
                  <div className="flex items-center justify-between" data-id="element-9064">
                    <div className="flex items-center gap-3" data-id="element-9065">
                      <button className="flex items-center gap-1 group" onClick={() => toggleLike(post.id)} data-id="element-9066">
                        <Heart size={18} className={likedPosts[post.id] ? 'text-pink-500' : 'text-gray-500 dark:text-gray-400 group-hover:text-pink-400'} fill={likedPosts[post.id] ? 'currentColor' : 'none'} data-id="element-9067" />
                        <span className="text-xs" data-id="element-9068">
                          {likedPosts[post.id] ? post.likes + 1 : post.likes}
                        </span>
                      </button>
                      <button className="flex items-center gap-1" data-id="element-9069">
                        <MessageCircle size={18} className="text-gray-500 dark:text-gray-400" data-id="element-9070" />
                        <span className="text-xs" data-id="element-9071">{post.comments}</span>
                      </button>
                      <button className="flex items-center gap-1" data-id="element-9072">
                        <Share2 size={18} className="text-gray-500 dark:text-gray-400" data-id="element-9073" />
                        <span className="text-xs" data-id="element-9074">Share</span>
                      </button>
                    </div>
                    <button className="flex items-center gap-1" data-id="element-9075">
                      <Gift size={18} className="text-pink-400" data-id="element-9076" />
                      <span className="text-xs" data-id="element-9077">Gift</span>
                    </button>
                  </div>
                  <div className="flex items-center gap-1 mt-2" data-id="element-9078">
                    <div className="flex -space-x-2" data-id="element-9079">
                      <div className="w-5 h-5 rounded-full border border-white dark:border-gray-900 bg-gray-300 dark:bg-gray-700" data-id="element-9080"></div>
                      <div className="w-5 h-5 rounded-full border border-white dark:border-gray-900 bg-gray-300 dark:bg-gray-700" data-id="element-9081"></div>
                    </div>
                    <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9082">
                      Liked by Jake and {(post.likes - 1).toLocaleString()}{' '}
                      others
                    </span>
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-9083">
                    View all {post.comments} comments
                  </div>
                </div>
              </div>)}
            {/* Mission Card */}
            <div className="bg-gradient-to-r from-pink-900/30 to-purple-900/30 rounded-xl border border-pink-800/50 p-4 shadow-md hover:shadow-xl hover:shadow-pink-600/5 transition-all duration-300" data-id="element-9084">
              <div className="flex items-center gap-3" data-id="element-9085">
                <div className="w-10 h-10 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-9086">
                  🔥
                </div>
                <div data-id="element-9087">
                  <h3 className="font-medium" data-id="element-9088">Daily Mission</h3>
                  <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-9089">
                    Like 3 of Lana's posts
                  </p>
                </div>
              </div>
              <div className="mt-3" data-id="element-9090">
                <div className="flex items-center justify-between mb-1" data-id="element-9091">
                  <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9092">
                    Progress
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9093">
                    {Object.values(likedPosts).filter(Boolean).length}/3
                  </span>
                </div>
                <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-9094">
                  <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
                  width: `${Math.min(Object.values(likedPosts).filter(Boolean).length / 3 * 100, 100)}%`
                }} data-id="element-9095"></div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-3" data-id="element-9096">
                <div className="flex items-center gap-1" data-id="element-9097">
                  <span className="text-pink-400" data-id="element-9098">💗</span>
                  <span className="text-sm" data-id="element-9099">+25</span>
                </div>
                <button className="text-xs px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-9100">
                  View Posts
                </button>
              </div>
            </div>
          </div>;
    }
  };
  return <section className="w-full max-w-[860px] mx-auto px-4 space-y-4 bg-white dark:bg-gray-950 text-gray-900 dark:text-white angel-feed-container" data-id="element-9101">
      {/* Header */}
      <div className="sticky top-0 z-20 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm p-3 flex items-center justify-between border-b border-gray-200 dark:border-gray-800" data-id="element-9102">
        <div className="flex items-center gap-4" data-id="element-9103">
          <button className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" onClick={() => {
          // Navigate back to AllAngelsGrid
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'all_angels'
            }
          });
          document.dispatchEvent(navigateEvent);
          // Still call the original onBack for any cleanup
          onBack();
        }} data-id="element-9104">
            <ArrowLeft size={20} className="text-gray-700 dark:text-gray-300" data-id="element-9105" />
          </button>
          <div data-id="element-9106">
            <h1 className="font-bold text-lg" data-id="element-9107">Lana</h1>
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9108">
              312K Followers
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-9109">
          <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-gray-800 dark:text-white text-xs font-medium" onClick={() => setShowImageGeneratorModal(true)} data-id="element-9110">
            <ImageIcon size={12} className="text-pink-400" data-id="element-9111" />
            <span data-id="element-9112">Generate Image</span>
          </button>
          <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-gray-800 dark:text-white text-xs font-medium" onClick={() => setShowVideoUpsellModal(true)} data-id="element-9113">
            <Video size={12} className="text-pink-400" data-id="element-9114" />
            <span data-id="element-9115">Generate Video</span>
          </button>
          <div className="relative" data-id="element-9116">
            <button className="p-2 bg-gray-100 dark:bg-gray-800 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700" onClick={() => setShowNotificationOptions(!showNotificationOptions)} data-id="element-9117">
              {notificationEnabled ? <Bell size={20} className="text-gray-700 dark:text-gray-300" data-id="element-9118" /> : <BellOff size={20} className="text-gray-700 dark:text-gray-300" data-id="element-9119" />}
            </button>
            {showNotificationOptions && <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-800 z-10" data-id="element-9120">
                <button className="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-t-lg flex items-center gap-2" onClick={toggleNotification} data-id="element-9121">
                  {notificationEnabled ? <>
                      <BellOff size={16} className="text-gray-700 dark:text-gray-300" data-id="element-9122" />
                      <span data-id="element-9123">Disable notifications</span>
                    </> : <>
                      <Bell size={16} className="text-gray-700 dark:text-gray-300" data-id="element-9124" />
                      <span data-id="element-9125">Enable notifications</span>
                    </>}
                </button>
              </div>}
          </div>
          <button className={`px-4 py-1.5 rounded-full font-bold ${isFollowing ? 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white hover:bg-red-600 hover:text-white' : 'bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:opacity-90'}`} onClick={toggleFollow} data-id="element-9126">
            {isFollowing ? 'Following' : 'Follow'}
          </button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" data-id="element-9127">
            <Sparkles size={16} className="text-pink-400" data-id="element-9128" />
          </button>
        </div>
      </div>
      {/* Profile Header */}
      <div className="relative" data-id="element-9129">
        <div className="h-32 w-full bg-gradient-to-r from-pink-600 to-purple-600 rounded-t-xl" data-id="element-9130"></div>
        <div className="absolute -bottom-16 left-4 w-32 h-32 rounded-full border-4 border-white dark:border-gray-950 overflow-hidden" data-id="element-9131">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg" alt="Lana" className="w-full h-full object-cover image-high-quality" loading="lazy" data-id="element-9132" />
        </div>
      </div>
      {/* Profile Info */}
      <div className="mt-20 px-4 ml-36" data-id="element-9133">
        <div className="flex items-center gap-1" data-id="element-9134">
          <h2 className="text-xl font-bold" data-id="element-9135">Lana</h2>
          <CheckCircle size={16} className="text-pink-400" fill="currentColor" data-id="element-9136" />
          <span className="text-sm font-normal text-pink-400 ml-2" data-id="element-9137">💋👑</span>
        </div>
        <p className="text-gray-500 dark:text-gray-400" data-id="element-9138">@lana_luxe</p>
        <p className="mt-2" data-id="element-9139">
          Your blonde fantasy come true... Let me show you what's beneath the
          surface 💋
        </p>
        <div className="flex gap-4 mt-3 text-sm" data-id="element-9140">
          <div className="flex items-center gap-1" data-id="element-9141">
            <span className="font-bold" data-id="element-9142">89</span>
            <span className="text-gray-500 dark:text-gray-400" data-id="element-9143">Following</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-9144">
            <span className="font-bold" data-id="element-9145">312K</span>
            <span className="text-gray-500 dark:text-gray-400" data-id="element-9146">Followers</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-9147">
            <span className="font-bold" data-id="element-9148">420</span>
            <span className="text-gray-500 dark:text-gray-400" data-id="element-9149">
              Intimacy XP
            </span>
          </div>
        </div>
      </div>
      {/* Feed Filter Bar - New Component */}
      <FeedFilterBar activeFilter={activeFilter} setActiveFilter={setActiveFilter} angelContext="Lana" data-id="element-9150" />
      {/* Navigation Tabs */}
      <div ref={navBarRef} className="sticky top-32 z-10 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800 relative" data-id="element-9151">
        <button className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 dark:bg-gray-800/80 rounded-full text-gray-500 dark:text-gray-400 hover:text-gray-800" onClick={() => scrollNavBar('left')} data-id="element-9152">
          <ChevronRight size={18} className="rotate-180" data-id="element-9153" />
        </button>
        <div ref={tabsRef} className="overflow-x-auto scrollbar-hide py-1 px-8" data-id="element-9154">
          <div className="flex min-w-max" data-id="element-9155">
            <button className={`px-4 py-3 flex items-center gap-1.5 relative ${activeTab === 'feed' ? 'text-pink-500 dark:text-pink-400 font-medium' : 'text-gray-700 dark:text-gray-400'}`} onClick={() => setActiveTab('feed')} data-id="element-9156">
              <span data-id="element-9157">🔥</span>
              <span className="whitespace-nowrap" data-id="element-9158">Feed</span>
              {activeTab === 'feed' && <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-pink-500 dark:bg-pink-400" data-id="element-9159"></span>}
            </button>
            <button className={`px-4 py-3 flex items-center gap-1.5 relative ${activeTab === 'dailyTargets' ? 'text-pink-500 dark:text-pink-400 font-medium' : 'text-gray-700 dark:text-gray-400'}`} onClick={() => setActiveTab('dailyTargets')} data-id="element-9160">
              <span data-id="element-9161">🎯</span>
              <span className="whitespace-nowrap" data-id="element-9162">Daily Targets</span>
              {activeTab === 'dailyTargets' && <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-pink-500 dark:bg-pink-400" data-id="element-9163"></span>}
            </button>
            <button className={`px-4 py-3 flex items-center gap-1.5 relative ${activeTab === 'dickpicRating' ? 'text-pink-500 dark:text-pink-400 font-medium' : 'text-gray-700 dark:text-gray-400'}`} onClick={() => setActiveTab('dickpicRating')} data-id="element-9164">
              <span data-id="element-9165">🍆</span>
              <span className="whitespace-nowrap" data-id="element-9166">Dickpic Rating</span>
              {activeTab === 'dickpicRating' && <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-pink-500 dark:bg-pink-400" data-id="element-9167"></span>}
            </button>
            <button className={`px-4 py-3 flex items-center gap-1.5 relative ${activeTab === 'memory' ? 'text-pink-500 dark:text-pink-400 font-medium' : 'text-gray-700 dark:text-gray-400'}`} onClick={() => setActiveTab('memory')} data-id="element-9168">
              <span data-id="element-9169">🧠</span>
              <span className="whitespace-nowrap" data-id="element-9170">Memory</span>
              {activeTab === 'memory' && <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-pink-500 dark:bg-pink-400" data-id="element-9171"></span>}
            </button>
            <button className={`px-4 py-3 flex items-center gap-1.5 relative ${activeTab === 'emotionalBond' ? 'text-pink-500 dark:text-pink-400 font-medium' : 'text-gray-700 dark:text-gray-400'}`} onClick={() => setActiveTab('emotionalBond')} data-id="element-9172">
              <span data-id="element-9173">💖</span>
              <span className="whitespace-nowrap" data-id="element-9174">Bond</span>
              {activeTab === 'emotionalBond' && <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-pink-500 dark:bg-pink-400" data-id="element-9175"></span>}
            </button>
            <button className={`px-4 py-3 flex items-center gap-1.5 relative ${activeTab === 'voiceAI' ? 'text-pink-500 dark:text-pink-400 font-medium' : 'text-gray-700 dark:text-gray-400'}`} onClick={() => setActiveTab('voiceAI')} data-id="element-9176">
              <span data-id="element-9177">🎤</span>
              <span className="whitespace-nowrap" data-id="element-9178">Voice</span>
              {activeTab === 'voiceAI' && <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-pink-500 dark:bg-pink-400" data-id="element-9179"></span>}
            </button>
            <button className={`px-4 py-3 flex items-center gap-1.5 relative ${activeTab === 'relationshipTracker' ? 'text-pink-500 dark:text-pink-400 font-medium' : 'text-gray-700 dark:text-gray-400'}`} onClick={() => setActiveTab('relationshipTracker')} data-id="element-9180">
              <span data-id="element-9181">📊</span>
              <span className="whitespace-nowrap" data-id="element-9182">Relationship</span>
              {activeTab === 'relationshipTracker' && <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-pink-500 dark:bg-pink-400" data-id="element-9183"></span>}
            </button>
          </div>
        </div>
        <button className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 dark:bg-gray-800/80 rounded-full text-gray-500 dark:text-gray-400 hover:text-gray-800" onClick={() => scrollNavBar('right')} data-id="element-9184">
          <ChevronRight size={18} data-id="element-9185" />
        </button>
      </div>
      {/* Main Content */}
      <div className="px-4 pb-4 angel-feed-post" data-id="element-9186">{renderTabContent()}</div>
      {/* Floating Action Button - New Component */}
      <FloatingActionButton onActionSelect={handleActionSelect} angelContext="Lana" data-id="element-9187" />
      {/* Unlock Modal */}
      {showUnlockModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-9188">
          <div className="w-full max-w-sm bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300 shadow-2xl" data-id="element-9189">
            <div className="p-4 border-b border-gray-200 dark:border-gray-800" data-id="element-9190">
              <h3 className="font-bold" data-id="element-9191">Unlock Premium Content</h3>
            </div>
            <div className="p-4" data-id="element-9192">
              <p className="text-sm text-gray-700 dark:text-gray-300 mb-4" data-id="element-9193">
                Unlock this exclusive content from Lana for 5 gems. This is a
                one-time purchase.
              </p>
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-9194">
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-2xl" data-id="element-9195">
                  💎
                </div>
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-9196">
                <span className="text-sm" data-id="element-9197">Your balance:</span>
                <span className="font-bold" data-id="element-9198">15 💎</span>
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-9199">
                <span className="text-sm" data-id="element-9200">Cost:</span>
                <span className="font-bold text-pink-400" data-id="element-9201">-5 💎</span>
              </div>
              <div className="flex gap-2" data-id="element-9202">
                <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" onClick={() => setShowUnlockModal(false)} data-id="element-9203">
                  Cancel
                </button>
                <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={confirmUnlock} data-id="element-9204">
                  Unlock Now
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Video Generation Modal */}
      {showVideoUpsellModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-9205">
          <VideoGenerationUpsell onClose={() => setShowVideoUpsellModal(false)} onPurchase={(duration, tokens) => {
        // Handle purchase logic
        setShowVideoUpsellModal(false);
      }} data-id="element-9206" />
        </div>}
      {/* Image Generator Modal */}
      {showImageGeneratorModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-9207">
          <div className="relative w-full max-w-lg animate-in zoom-in-90 duration-300 bg-white dark:bg-gray-900 rounded-lg shadow-lg" data-id="element-9208">
            <button className="absolute right-4 top-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800" onClick={() => setShowImageGeneratorModal(false)} data-id="element-9209">
              <X size={18} className="text-gray-500 dark:text-gray-400" data-id="element-9210" />
            </button>
            <div className="p-6" data-id="element-9211">
              <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-4" data-id="element-9212">
                Generate Image with Lana
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6" data-id="element-9213">
                Create a custom image with Lana. Choose your options and
                generate a unique image.
              </p>
              <div className="space-y-4" data-id="element-9214">
                <div data-id="element-9215">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-9216">
                    Style
                  </label>
                  <input type="text" placeholder="Glamour" className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-800" data-id="element-9217" />
                </div>
                <div data-id="element-9218">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-9219">
                    Mood
                  </label>
                  <input type="text" placeholder="Seductive" className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-800" data-id="element-9220" />
                </div>
                <div data-id="element-9221">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-9222">
                    Special Request
                  </label>
                  <textarea placeholder="Describe what you'd like to see..." className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-800 min-h-[100px]" data-id="element-9223"></textarea>
                </div>
                <div data-id="element-9224">
                  <div className="flex items-center justify-between mb-2" data-id="element-9225">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-9226">
                      Cost:
                    </label>
                    <span className="text-pink-500 font-medium flex items-center gap-1" data-id="element-9227">
                      15 <span className="text-blue-500" data-id="element-9228">💎</span>
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-3" data-id="element-9229">
                    <button className="py-2 px-4 bg-gray-100 dark:bg-gray-800 rounded-md text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" onClick={() => setShowImageGeneratorModal(false)} data-id="element-9230">
                      Cancel
                    </button>
                    <button className="py-2 px-4 bg-gradient-to-r from-pink-600 to-purple-600 rounded-md text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-9231">
                      Generate Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Dickpic Rating Modal */}
      {showDickpicRatingModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-9232">
          <DickpicRatingUpsell onClose={() => setShowDickpicRatingModal(false)} onSelect={(tier, price) => {
        console.log(`Selected tier ${tier} for ${price} tokens`);
        setShowDickpicRatingModal(false);
      }} data-id="element-9233" />
        </div>}
      {/* Daily Targets Modal */}
      {showDailyTargetsModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-9234">
          <div className="relative w-full max-w-lg animate-in zoom-in-90 duration-300 bg-white dark:bg-gray-900 rounded-lg shadow-lg" data-id="element-9235">
            <button className="absolute right-4 top-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800" onClick={() => setShowDailyTargetsModal(false)} data-id="element-9236">
              <X size={18} className="text-gray-500 dark:text-gray-400" data-id="element-9237" />
            </button>
            <div className="p-6" data-id="element-9238">
              <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-4 flex items-center gap-2" data-id="element-9239">
                <Target size={20} className="text-pink-500" data-id="element-9240" />
                Daily Targets
              </h3>
              <div className="space-y-4" data-id="element-9241">
                <div className="p-4 bg-gradient-to-r from-pink-900/10 to-purple-900/10 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg border border-pink-200/20 dark:border-pink-800/30" data-id="element-9242">
                  <div className="flex items-center gap-3" data-id="element-9243">
                    <div className="w-10 h-10 flex items-center justify-center bg-pink-500/10 dark:bg-pink-500/20 rounded-full text-pink-500" data-id="element-9244">
                      <Heart size={20} data-id="element-9245" />
                    </div>
                    <div className="flex-1" data-id="element-9246">
                      <div className="flex items-center justify-between" data-id="element-9247">
                        <h3 className="font-medium" data-id="element-9248">Like 5 Posts</h3>
                        <div className="text-sm text-pink-500" data-id="element-9249">15 💗</div>
                      </div>
                      <p className="text-sm text-gray-700 dark:text-gray-300 mt-1" data-id="element-9250">
                        Show some love to Lana's content
                      </p>
                      <div className="mt-2" data-id="element-9251">
                        <div className="flex items-center justify-between mb-1" data-id="element-9252">
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9253">
                            Progress
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9254">
                            {Object.keys(likedPosts).length}/5
                          </span>
                        </div>
                        <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-9255">
                          <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
                        width: `${Object.keys(likedPosts).length / 5 * 100}%`
                      }} data-id="element-9256"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-4 bg-gradient-to-r from-pink-900/10 to-purple-900/10 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg border border-pink-200/20 dark:border-pink-800/30" data-id="element-9257">
                  <div className="flex items-center gap-3" data-id="element-9258">
                    <div className="w-10 h-10 flex items-center justify-center bg-pink-500/10 dark:bg-pink-500/20 rounded-full text-pink-500" data-id="element-9259">
                      <Gift size={20} data-id="element-9260" />
                    </div>
                    <div className="flex-1" data-id="element-9261">
                      <div className="flex items-center justify-between" data-id="element-9262">
                        <h3 className="font-medium" data-id="element-9263">Send a Gift</h3>
                        <div className="text-sm text-pink-500" data-id="element-9264">10 💗</div>
                      </div>
                      <p className="text-sm text-gray-700 dark:text-gray-300 mt-1" data-id="element-9265">
                        Send a gift to Lana to make her day
                      </p>
                      <div className="mt-2" data-id="element-9266">
                        <div className="flex items-center justify-between mb-1" data-id="element-9267">
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9268">
                            Progress
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-9269">
                            0/1
                          </span>
                        </div>
                        <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-9270">
                          <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
                        width: '0%'
                      }} data-id="element-9271"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-4 bg-gradient-to-r from-pink-900/10 to-purple-900/10 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg border border-pink-200/20 dark:border-pink-800/30" data-id="element-9272">
                  <div className="flex items-center gap-3" data-id="element-9273">
                    <div className="w-10 h-10 flex items-center justify-center bg-pink-500/10 dark:bg-pink-500/20 rounded-full text-pink-500" data-id="element-9274">
                      <Camera size={20} data-id="element-9275" />
                    </div>
                    <div className="flex-1" data-id="element-9276">
                      <div className="flex items-center justify-between" data-id="element-9277">
                        <h3 className="font-medium" data-id="element-9278">DickPic Challenge</h3>
                        <div className="text-sm text-pink-500" data-id="element-9279">25 💗</div>
                      </div>
                      <p className="text-sm text-gray-700 dark:text-gray-300 mt-1" data-id="element-9280">
                        Get a personal rating from Lana
                      </p>
                      <div className="mt-2" data-id="element-9281">
                        <button className="w-full py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={() => {
                      setShowDailyTargetsModal(false);
                      setShowDickpicRatingModal(true);
                    }} data-id="element-9282">
                          Start Challenge
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6 p-4 bg-gradient-to-r from-blue-900/10 to-purple-900/10 dark:from-blue-900/20 dark:to-purple-900/20 rounded-lg border border-blue-200/20 dark:border-blue-800/30" data-id="element-9283">
                <div className="flex items-center justify-between mb-2" data-id="element-9284">
                  <h3 className="font-medium" data-id="element-9285">Daily Streak</h3>
                  <div className="flex items-center gap-1" data-id="element-9286">
                    <span className="text-yellow-500" data-id="element-9287">🔥</span>
                    <span className="font-bold" data-id="element-9288">3 Days</span>
                  </div>
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-9289">
                  Complete all daily targets to maintain your streak and earn
                  bonus rewards!
                </p>
              </div>
            </div>
          </div>
        </div>}
      <style jsx data-id="element-9290">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .angel-feed-container {
          max-width: 860px;
          margin: 0 auto;
          padding: 0 16px;
        }
        @media (min-width: 1440px) {
          .angel-feed-container {
            max-width: 1080px;
          }
        }
        .angel-feed-post {
          max-width: 820px;
          margin: 0 auto;
        }
        .angel-post-image {
          width: 100%;
          height: auto;
          object-fit: cover;
          image-rendering: auto;
          border-radius: 0;
        }
        .image-high-quality {
          image-rendering: auto;
        }
      `}</style>
    </section>;
}